import { useEffect, useState } from "react";
import { StyledMenu } from "../../../users/components/user/style";
import { TrainerDetailsHeader } from "./components/header/TrainerDetailsHeader";
import { useParams, Outlet, useNavigate, useLocation } from "react-router-dom";
import { useAppSelector } from "../../../../store/config";
import { routes } from "../../../../navigation/routes";
import { useTranslation } from "react-i18next";
import { StyledOutletLayout } from "../../../../components/common/styles";

export const TrainerDetails = () => {
  const { t } = useTranslation();
  const { id: trainerId } = useParams<{ id: string }>();
  const location = useLocation();
  const isNew: boolean = location.pathname === "/trainers/add";
  const navigate = useNavigate();
  const [currentTab, setCurrentTab] = useState("personal");

  const { trainer } = useAppSelector((state) => state.trainer);
  const { trainingProgram } = useAppSelector((state) => state.trainingProgram);
  const { workout } = useAppSelector((state) => state.workout);
  const { exercise } = useAppSelector((state) => state.exercise);
  const { vod } = useAppSelector((state) => state.vod);

  useEffect(() => {
    if (trainer?._id && location.pathname === "/trainers/add") {
      navigate(`/trainers/${trainer._id}`, { replace: true });
    }
  }, [trainer?._id, navigate, location.pathname]);

  useEffect(() => {
    const pathParts = location.pathname.split("/");
    const activeTab = pathParts.includes("exercises")
      ? "exercises"
      : pathParts.includes("training-programs")
      ? "training-programs"
      : pathParts.includes("workouts")
      ? "workouts"
      : pathParts.includes("technique-videos")
      ? "technique-videos"
      : pathParts.includes("dashboard")
      ? "dashboard"
      : "personal";
    setCurrentTab(activeTab);
  }, [location.pathname]);

  const menuItems = [
    {
      key: "personal",
      label: t("Personal Details"),
      disabled: false,
      path: `/trainers/${trainerId}`,
    },
    {
      key: "exercises",
      label: t("Exercise Library"),
      disabled: isNew,
      path: routes.trainerRoutes.exercises.replace(":id", trainerId || ""),
    },
    {
      key: "training-programs",
      label: t("Training Programs"),
      disabled: isNew,
      path: routes.trainerRoutes.trainingPrograms.replace(
        ":id",
        trainerId || ""
      ),
    },
    {
      key: "workouts",
      label: t("Individual Workouts"),
      disabled: isNew,
      path: routes.trainerRoutes.workouts.replace(":id", trainerId || ""),
    },
    {
      key: "technique-videos",
      label: t("Technique Videos"),
      disabled: isNew,
      path: routes.trainerRoutes.techniqueVideos.replace(
        ":id",
        trainerId || ""
      ),
    },
    {
      key: "dashboard",
      label: t("Dashboard"),
      disabled: isNew,
      path: routes.trainerRoutes.dashboard.replace(":id", trainerId || ""),
    },
  ];

  const shouldRenderMenu =
    !location.pathname.includes("/exercises/") &&
    !location.pathname.includes("/training-programs/") &&
    !location.pathname.includes("/workouts/") &&
    !location.pathname.includes("/technique-videos/") &&
    !location.pathname.includes("/dashboard/");

  return (
    <StyledOutletLayout>
      <TrainerDetailsHeader
        trainerName={trainer?.fullName}
        trainingProgramName={trainingProgram?.name}
        workoutName={workout?.name}
        exerciseName={exercise?.name}
        techniqueVideoName={vod?.name}
      />
      {shouldRenderMenu && (
        <StyledMenu
          onClick={(e) => {
            if (!isNew) {
              setCurrentTab(e.key);
              navigate(
                menuItems.find((item) => item.key === e.key)?.path ||
                  `/trainers/${trainerId}`
              );
            }
          }}
          selectedKeys={[currentTab]}
          mode="horizontal"
          items={menuItems}
        />
      )}

      <Outlet
        context={{
          trainer: trainer,
          isEditable: false,
          handleUserUpdate: () => {},
        }}
      />
    </StyledOutletLayout>
  );
};

export default TrainerDetails;
